import type { Interaction } from "@/types";

type EmptyPlayerStateProps = {
  interaction: Interaction;
};

export default function EmptyPlayerState({ interaction }: EmptyPlayerStateProps) {
  if (interaction.status === "running") {
    return (
      <div className="text-center">
        <div className="mb-2 text-lg text-gray-500">Initializing interaction</div>
        <div className="text-sm text-gray-400">You will be able to see the progress here in a bit.</div>
      </div>
    );
  }

  if (interaction.status === "pending") {
    return (
      <div className="text-center">
        <div className="mb-2 text-lg text-gray-500">On queue</div>
        <div className="text-sm text-gray-400">Waiting for the interaction to start.</div>
      </div>
    );
  }

  return <div className="text-gray-500">No frames available</div>;
}
